import { useState } from 'react';
import { SLIDES } from '../constants';
import Navbar from './Navbar';
import HeroSlider from './HeroSlider';
import LinksSection from './LinksSection';
import StatsStrip from './StatsStrip';
import Footer from './Footer';
import styles from './Landing.module.css';

export default function Landing() {
  const [accent, setAccent] = useState(SLIDES[0].accent);

  return (
    <div className={styles.root}>
      {/* Navbar flotante sobre el slider */}
      <header className={styles.navWrapper}>
        <Navbar accent={accent} />
      </header>

      {/* Hero con slider fullscreen */}
      <HeroSlider onAccentChange={setAccent} />

      {/* Link bio */}
      <LinksSection accent={accent} />

      {/* Estadísticas */}
      <StatsStrip accent={accent} />

      {/* Footer */}
      <Footer accent={accent} />
    </div>
  );
}
